import { IStore } from "helpers";
import { createSlice } from "@reduxjs/toolkit";

export const dataManagementReducer = createSlice({
  name: "dataManagement store",
  initialState: { 
    buyerNameUpdate: "New Buyer",
    haulierNameUpdate: "New Haulier",
  },
  reducers: { 
    setBuyerNameUpdate: (state, action) => {
      state.buyerNameUpdate = action.payload;
    },
    setHaulierNameUpdate: (state, action) => {
      state.haulierNameUpdate = action.payload;
    },
  },
});
export const { setBuyerNameUpdate, setHaulierNameUpdate} = dataManagementReducer.actions;

export const getBuyerNameUpdate = (state: IStore) => state.dataManagement.buyerNameUpdate;
export const getHaulierNameUpdate = (state: IStore) => state.dataManagement.haulierNameUpdate;

export default dataManagementReducer.reducer;
